import React from 'react';
import FieldForm from '@/components/admin/field/FieldForm';

const AddField: React.FC = () => {
  return <FieldForm mode="create" />;
};

export default AddField;
